import React, { useCallback, useEffect, useState } from 'react';

import { CharacterSheetInterface, Weapon, WEAPON_KEYWORDS, WeaponKeyword, WeaponMasteryProperty } from "@dndModels";

import FlexBox from '@components/layout/FlexBox';
import CommonUtilities from '@utilities/common_utilities';
import SelectStringBox from '@components/input/selects/SelectStringBox';
import SelectObjectBox from '@components/input/selects/SelectObjectBox';
import LoadingBox from '@components/input/LoadingBox';
import DataUtilities from '@dndUtilities/data_utilities';
import DisplayObjects from '@dndComponents/display/DisplayObjects';

interface Props {
  char: CharacterSheetInterface;
}

const common_util = CommonUtilities.getInstance();
const data_util = DataUtilities.getInstance();

export default function CharacterWeaponMasteryCustomizations({
  char,
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [ping, setPing] = useState(false);
  const [weapons, setWeapons] = useState<Weapon[]>([]);

  const customizations = char.customizations;

  const load = useCallback( async () => {
    const items = data_util.items;
    setWeapons(items.filter(o => o instanceof Weapon) as Weapon[]);
    setLoading(false);
  }, []);

  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      setLoading(true);
      setTimeout(() => {
        load();
      }, 100);
    }
  }, [fetched]);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  const renderWeaponMasteryCustomization = (weapon: Weapon) => {
    // debugger;
    const cwm = char.mind.cwms.find(o => o.weapon_limits.some(o2 => o2.item_ids.includes(weapon._id)));
    const wmp = data_util.weapon_mastery_properties.find(o => o._id === weapon.weapon_mastery_property_id);
    return (
      <FlexBox key={weapon._id}>
        <FlexBox direction="row">
          <FlexBox xs_expand={0} style={{ width: "30%"}}>
            <FlexBox direction="column">
              <FlexBox>{ weapon.name }</FlexBox>
              { cwm && 
                <FlexBox className="small_label gray"><DisplayObjects type="weapon_mastery_property" ids={[cwm.source_id]} /></FlexBox>
              }
              { customizations.weapon_mastery_overrides[weapon._id] !== undefined &&
                <FlexBox className="small_label gray">Overridden</FlexBox>
              }
            </FlexBox>
          </FlexBox>
          <FlexBox>
            <SelectObjectBox 
              name="Override"
              value={ customizations.weapon_mastery_overrides[weapon._id] === undefined ? "Don't Override" : (customizations.weapon_mastery_overrides[weapon._id]) } 
              data_type="weapon_mastery_property"
              extra_options={[{ id: "Don't Override", text: "Don't Override" },{ id: "Standard", text: `Standard${wmp ? " (" + wmp.name + ")" : ""}` }]}
              onChange={ async (changed: string) => {
                if (changed === "Don't Override") {
                  delete customizations.weapon_mastery_overrides[weapon._id];
                } else {
                  customizations.weapon_mastery_overrides[weapon._id] = changed;
                }
                setPing(!ping);
                char.changed();
                char.subscription_holder.recalculate();
              }}
            />
          </FlexBox>
        </FlexBox>
      </FlexBox>
    );
  }

  if (!fetched || loading) {
    return (<LoadingBox />);
  }
  return (
    <FlexBox direction="column" style={{ width: "100%" }}>
      { weapons.sort((a, b) => {
        return a.name.localeCompare(b.name);
      }).map(weapon => renderWeaponMasteryCustomization(weapon))}
    </FlexBox>
  );
}

